document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.live-sorting-input').forEach(input => {
    const list = input.closest('.details-dialog__search').nextElementSibling.matches('.live-sorting-list')
      ? input.closest('.details-dialog__search').nextElementSibling
      : null;

    if (!list) return;

    const items = list.querySelectorAll('.live-sorting-item');

    input.addEventListener('input', (e) => {
      const value = e.target.value.toLowerCase().trim();

      [...items].forEach(item => {
        const title = item.querySelector('.live-sorting-target').textContent.toLowerCase().trim();

        title.includes(value)
          ? item.style.display = 'flex'
          : item.style.display = 'none';
      });
    });
  });
});
